module.exports = __webpack_public_path__ + "img/img-712c91.jpg";